export default function colorId(role) {
  const colorsIds = {
    ROLE_AMCRED_GESTOR: 0,
    ROLE_INSTITUICAO_ASSOCIADA_GESTOR: 1,
    ROLE_INSTITUICAO_ASSOCIADA_ANALISTA_DE_CRÉDITO: 1,
  };

  return colorsIds[role];
}
